import React, { useRef, useState } from 'react'
import { useDebounceFn } from 'ahooks';
import { Steps, Input, Select, Form, Button, Checkbox, message, InputNumber, Tabs, Tooltip, Card } from 'antd'
import { ajaxApi, getMethod } from '@/server/index'
import _lodash, { debounce, get } from 'lodash'
import common from '@/public/common'
import logo from '../../../logo.svg'
import style from './../index.module.less'
import { CheckCircleFilled, QuestionCircleOutlined } from '@ant-design/icons'
import { md5hex } from '@/public/utils'
const { Step } = Steps
const FormItem = Form.Item
const Option = Select.Option
const CheckboxGroup = Checkbox.Group
const { TabPane } = Tabs
const FindPassword = () => {
  const reqID = useRef(null)
  const [companyName, setCompanyName] = useState("")
  const [current, setcurrent] = useState(0)
  const [disabledstatus, setdisabledstatus] = useState(false)
  const [btnText, setbtnText] = useState('获取验证码')
  const [activetab, setactivetab] = useState(1)
  const [paramData, setparamData] = useState({})
  const [sid, setsid] = useState(null)
  const [account, setaccount] = useState('')
  const [codetype, setcodetype] = useState([])
  const [sendcode, setsendcode] = useState('')
  const [verification_code, setverification_code] = useState('')
  const [newpassword, setnewpassword] = useState('')
  const [secondpassword, setsecondpassword] = useState('')
  // 倒计时60秒
  const handleCountDown = (seconds) => {
    let second = seconds
    const countDown = () => {
      if (second > 0) {
        second--
        const codeText = '倒计时' + '(' + second + ')'
        setbtnText(codeText)
        setdisabledstatus(true)
      }
      if (second === 0) {
        second = 60
        setbtnText('获取验证码')
        setdisabledstatus(false)
        return
      }
      setTimeout(countDown, 1000)
    }
    setTimeout(countDown, 1000)
  }
  // 获取验证码
  const handleVerificationCode = async () => {
    const postData = {
      send_id: sendcode,
      type: 4,
      sms: activetab == 1 ? true : false
    }
    if (sendcode === '') {
      message.warning("请选择验证方式！")
      // message.warning('请填写' + (activetab == 1 ? '手机' : '邮箱') + '号码', 2)
      return false
    }
    try {
      let res = await ajaxApi({
        url: common.eurekaUrlDic + "/auth/send-verify-code",
        params: postData,
      })
      console.log(res)
      if (get(res, "data.code") == 200) {
        handleCountDown(60)
        //   setParamData({...paramData, verify_code: re})
      }
    } catch (err) {
      return null
    }
  }

  const {run: getAccountInfo } = useDebounceFn(
    async() => {
      let _account = account ? account.trim() : ""
      if (_account) {
        const { data } = await getMethod(common.eurekaUrlDic + `/auth/query-account?account=${_account}`)
        console.log(data)
        if (get(data, "data.account")) {
          setCompanyName(get(data, "data.real_name"))
        } else {
          setCompanyName("")
          if (get(data, "message")) {
            message.warn(get(data, "message"))
          }
        }
      }
    },
    {
      wait: 800,
    },
  );

  const getCurrentDom = () => {
    let domtext = null
    if (current == 0) {
      domtext = <div style={{ position: "relative" }}>
        <span style={{ color: 'red' }}>*</span><span> 账号信息 ：</span>
        <Tooltip title="如所有账号信息都忘记，请与视客对应的采购人员联系获取！">
          <QuestionCircleOutlined />
        </Tooltip>
        <Input  placeholder="请输入" style={{ display: 'inline-block', width: '300px', marginLeft: '16px', marginBottom: '24px', marginTop: '48px' }} 
        onChange={(e) => { setaccount(e.target.value);getAccountInfo() }} 
        />
        <div style={{ textAlign: "center", color: "#ccc" }}>{companyName}</div>
      </div>
    } else if (current == 1) {
      domtext = <div style={{ marginTop: '48px' }}>
        <div style={{ marginBottom: '24px', marginTop: '24px' }}>
          <span style={{ display: 'inline-block', width: '150px', textAlign: 'right' }}>  <span style={{ color: 'red' }}>*</span>验证方式 ：</span>
          <Select
            onChange={(e) => { setsendcode(e); var phone = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/; setactivetab(phone.test(e) ? 2 : 1) }}
            placeholder="请选择"
            style={{ display: 'inline-block', width: '408px', marginLeft: '16px' }}
          >
            {codetype.map((i, index) => <Option key={index} value={i.value}>{i.label}</Option>)}
          </Select>
          {get(codetype,"length")?null:<div style={{color:"orange",textAlign:"center",marginTop:24}}>如果没有绑定手机号码或者邮箱，请联系采购重置密码</div>}
          {sendcode ? <div style={{ marginTop: '24px' }}>当前绑定 {activetab == 1 ? '手机号' : '邮箱地址'}是 {sendcode}
            <span style={{ color: "orange", marginLeft: 8 }}>若要换绑，请先联系视客采购重置密码！</span>
          </div> : null}
        </div>
        <div>
          <span style={{ display: 'inline-block', width: '150px', textAlign: 'right' }}> <span style={{ color: 'red' }}>*</span>验证码 ：</span>
          <Input placeholder="请输入" onChange={(e) => {
            setverification_code(e.target.value)
          }} maxLength={6} style={{ display: 'inline-block', width: '300px', marginLeft: '16px', marginBottom: '24px' }} />
          <Button type="primary" id='btnDom' disabled={disabledstatus} style={{ marginLeft: '8px' }} onClick={handleVerificationCode}>{btnText}</Button>
        </div>
      </div>
    } else if (current == 2) {
      domtext = <div style={{ marginTop: '48px' }}>
        <div>
          <span style={{ color: 'red' }}>*</span><span> 新的登录密码 ：</span>
          <Input.Password onChange={(e) => { setnewpassword(e.target.value) }} placeholder="密码由6-16位字母数字组合，区分大小写" style={{ width: '300px' }} />
        </div>
        <div style={{ marginTop: '24px' }}>
          <span style={{ color: 'red' }}>*</span><span> 确认登录密码 ：</span>
          <Input.Password onChange={(e) => { setsecondpassword(e.target.value) }} placeholder="请再次确认密码" style={{ width: '300px' }} />
        </div>
      </div>
    } else if (current == 3) {
      domtext = <div style={{ marginTop: '48px', marginLeft: '100px' }}>
        <FormItem><CheckCircleFilled style={{ color: 'limegreen', fontSize: '60px' }} /><div style={{ marginTop: '24PX' }}>重置密码成功，请牢记新的登录密码</div></FormItem>
      </div>
    }
    return domtext
  }

  // 下一步
  const nextfun = () => {
    if (current == 0) {
      // 获取账号信息
      getaccountInfo()
    } else if (current == 1) {
      // 验证码校验
      codeistrue()
    } else if (current == 2) {
      changePassword()
    }
  }
  // 验证账户是否注册
  const getaccountInfo = async () => {
    let _account = account
    _account = _account ? _account.trim() : ""
    if(!_account){
      return message.warn("请输入账号信息")
    }
    const res = await getMethod(common.eurekaUrlDic + `/auth/query-account?account=${_account}`)
    if (get(res, "data.data.account")) {
      let authWaysRes = await getMethod(common.eurekaUrlDic + `/auth/query-auth-way?account=${_account}`)
      let phone = get(authWaysRes, "data.data.phone_number")
      let email = get(authWaysRes, "data.data.email")
      // 获取验证方式
      setcodetype([
        { label: '手机号+验证码验证', value: phone },
        { label: '邮箱+验证码验证', value: email },
      ].filter(i => i.value))
      setcurrent(current + 1)
    } else if (get(res, "data.message")) {
      message.warn(get(res, "data.message"))
    }
  }
  // 校验验证码是否正确
  const codeistrue = async () => {
    let _account = account ? account.trim() : ""
    let _verification_code = verification_code ? verification_code.trim() : ""
    let params = {
      account: _account,
      send_id: sendcode,
      verify_code: _verification_code,
      // sms: activetab == 1 ? true : false
    }
    let _res = await ajaxApi({
      url: common.eurekaUrlDic + "/auth/retrieve-verify",
      params,
    })
    if (get(_res, "data.data.req_id")) {
      reqID.current = get(_res, "data.data.req_id")
      setcurrent(current + 1)
    } else if (get(_res, "data.message")) {
      message.warn(get(_res, "data.message"))
    }
  }
  // 修改密码
  const changePassword = async () => {
    if (newpassword != secondpassword) {
      message.error('两次输入密码不一致！')
      return false
    }
    var regu = '^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$'
    var re = new RegExp(regu)
    if (!re.test(newpassword)) {
      message.error('密码由6-16位字母数字组合，区分大小写!')
      return false
    }
    const res = await ajaxApi({
      url: common.eurekaUrlDic + '/auth/upd-pwd',
      params: { new_pwd: md5hex(newpassword), req_id: reqID.current }
    })
    if (get(res, "data.code") == 200) {
      setcurrent(current + 1)
    } else if (get(res, "data.message")) {
      message.warn(get(res, "data.message"))
    }
  }
  return (
    <div style={{}}>
      <Card style={{ width: '800px', textAlign: 'center', margin: '200px auto' }}>
        <div style={{ fontSize: '32px', fontWeight: 600, margin: '24px 0px', marginTop: '0', textAlign: 'left' }}>找回密码</div>
        <div style={{ width: '700px', margin: '24px auto' }}>
          <Steps current={current}>
            <Step title="填写账号信息" description="" />
            <Step title="验证身份" description="" />
            <Step title="重置密码" description="" />
            <Step title="完成" description="" />
          </Steps>
        </div>

        <div style={{ width: '700px', textAlign: 'center', marginBottom: '24px' }}>
          {getCurrentDom()}
        </div>
        <div style={{ width: '800px', textAlign: 'center', marginBottom: '24px' }}>
          {
            current != 3 ? <Button type="primary" style={{ width: '300px', marginLeft: '10px' }} onClick={nextfun} size="large">下一步</Button> : <Button style={{ width: '300px' }} type="primary" size="large" onClick={() => { window.location.href = "/" }}>立即登录</Button>
          }
        </div>
      </Card>
    </div>
  )
}
export default FindPassword



// WEBPACK FOOTER //
// ./src/pages/suppliersettlement/findpassword/findpassword.js